import { createStore, applyMiddleware, compose } from "redux"
import { routerMiddleware } from "react-router-redux"
import createSagaMiddleware from "redux-saga"
import { persistStore } from "redux-persist"
import { createTracker } from "redux-segment"
import createRavenMiddleware from "raven-for-redux"
import history from "./history"
import rootReducer from "./redux"
import sagas from "./sagas"
import Raven from "./utils/raven"
import initialState from "./initialState"

const tracker = createTracker() // redux-analytics tracker

export default () => {
  const enhancers = []
  const sagaMiddleware = createSagaMiddleware()

  const middleware = [
    sagaMiddleware,
    routerMiddleware(history),
    tracker,
    createRavenMiddleware(Raven)
  ]

  if (process.env.NODE_ENV === "development") {
    const devToolsExtension = window.devToolsExtension

    if (typeof devToolsExtension === "function") {
      enhancers.push(devToolsExtension())
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  )

  const store = createStore(rootReducer, initialState, composedEnhancers)

  let persistor = persistStore(store)

  sagaMiddleware.run(sagas)

  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store.js